
class ProductPreSell {
    constructor(product_id) {
        this.pre_sell_reference = product_id;
        this.product_presells = null;
        this.presells = null;
        this.init();
    }

    async getPreSellIncomingDate(variant_id){
        let Incomings = await _EVClient.GetIncomings()
        return Incomings.find(function(incoming){
            return parseInt(incoming.partnerId) === variant_id;
        })
    }
    async getPreSells(){
        let PreSells = await axios.get(window.EvolveHUB.PreSell.API.baseUrl)
        return this.presells = PreSells.data.pre_sell
    }
    async getVariantDetails(variant_id){
        try {
            let variantQueryId =  btoa(`gid://shopify/ProductVariant/${variant_id}`)
            let VariantDetails = await axios.post('https://zissou.myshopify.com/api/2021-04/graphql.json', {
                    query: `
                        {
                            node(id: "${variantQueryId}") {
                                id
                                ... on ProductVariant {
                                    id
                                    title
                                    sku
                                    availableForSale
                                    quantityAvailable
                                }
                            }
                        }
                    `
                },
                {
                    headers: {
                        "Accept": "application/json",
                        "Content-Type":  "application/json",
                        'X-Shopify-Storefront-Access-Token': 'd1f5e8b3cd6eefe038b3695ead7b6c6c' //PROD
                        // 'X-Shopify-Storefront-Access-Token': 'bffd1a515497bc4c541a35c719279544' // DEV
                    }
                }
            )

            if(VariantDetails.data.data.node){
                return VariantDetails.data.data.node;
            }
            throw new Error('VARIANT_NOT_FOUND')
        } catch (error) {
            return console.error(error.message)
        }
    }
    async getProductPreSells() {
        try {
            if(!this.presells){
                await this.getPreSells()
            }
            let $result = this.presells.find(product => product._id === this.pre_sell_reference)
            let $ProductPreSells = await Promise.all($result.pre_sell_variants.map(async variant => {
                let variant_details = await this.getVariantDetails(variant._id)
                let PreSellIncoming = await this.getPreSellIncomingDate(variant._id)
                if(PreSellIncoming){
                    variant_details.incoming_date = PreSellIncoming ? PreSellIncoming.incomingDate : null
                }
                return {
                    ...variant,
                    ...variant_details
                }
            }))
            return $ProductPreSells.filter(product => !!product)
        } catch (error) {
            return console.error(error.message)
        }
    }
    async init() {
        await this.getPreSells();

        // this.product_presells = await this.getProductPreSells();

        // let xpto = new ProductPreSell('handle-1')
        // let ProductPreSells = xpto.product_presells
    }
}
// var xpto = new ProductPreSell(39483152728258)
// document.addEventListener("_EV.core:initialized", function (e) {
document.addEventListener("DOMContentLoaded", function(){ 
    Vue.component('presell-wrapper', {
        template: `
            <div class="PreSell" v-if="PreSellVariants">
                <div class="PreSell__CTA" toggle-presell-modal v-if="hasElegibleVariants">
                    NÃO TEM PRESSA PARA RECEBER? <br>
                    GANHE DESCONTOS ADICIONAIS
                </div>
                <div class="PreSell__Popup" v-bind:class="{'PreSell__Popup--active': PreSellPopup === true}" title="AGENDE SUA ENTREGA" :visible.sync="PreSellPopup">
                    <div class="PreSell__Popup__Inner">
                        <div class="PreSell__Popup__Header">
                            <a class="PreSell__Popup__Header--Close" @click="closePreSellDialog"><Icon icon="CloseIcon" /></a>
                        </div>
                        <div class="PreSell__Popup__Content">
                            <strong class="PreSell__Popup__Title">Se não tiver pressa para receber seu colchão zissou, aproveite descontos adicionais</strong>
                            <PreSell__Variants :variants="PreSellVariants" v-if="PreSellVariants" @has-elegible-variants="handleElegibleVariants($event)"/>
                        </div>
                        <div class="PreSell__Popup__Footer">
                            <a href="#" @click="closePreSellDialog">Quero o menor prazo</a>
                        </div>
                    </div>
                </div>
            </div>
        `,
        computed: {
            ...Vuex.mapGetters([
                'PreSell',
                'PreSellVariants'
            ]),
            // featuredVariant(){
            //     return this.PreSellVariants.pop()
            // }
        },
        data() {
            return {
                PreSellPopup: false,
                hasElegibleVariants: null
            }
        },
        created(){
            let $this = this;
            if(window.VariantPicker){
                $this.getPreSellVariants(window.VariantPicker[window.VariantPicker.length - 1].id)
                window.VariantPicker = null
            }
            document.addEventListener('_EV.VariantPicker:variant:set', function(e) {
                console.log(e.detail.id)
                $this.getPreSellVariants(e.detail.id)
            })
            document.addEventListener('_EV.PreSell:modal:open', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $this.PreSellPopup = true
            })
            document.addEventListener('_EV.PreSell:modal:close', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $this.PreSellPopup = false
            })
        },
        methods:{
            ...Vuex.mapActions([
                'getPreSellVariants'
            ]),
            openPreSellDialog(){
                return EvolveCore.triggerEvent(`PreSell:modal:open`);
            },
            closePreSellDialog(){
                return EvolveCore.triggerEvent(`PreSell:modal:close`);
            },
            addMostRecentPreSell(){
                return EvolveCore.triggerEvent(`PreSell:add_product:most_recent`);
            },
            handleElegibleVariants($hasElegibleVariants){
                this.hasElegibleVariants = $hasElegibleVariants;
            }
        }
    })
    Vue.component('PreSell__Variants', {
        template: `
            <div class="PreSell__Variants">
                <div v-for="(variant, index) in ElegiblePreSellVariants" :key="index" class="PreSell__Variants__Item">
                    <div class="PreSell__Variants__Item--Content">
                        <span v-if="variant.incoming_date">
                            Entregas entre 
                            <strong>
                                {{FormatDate(variant.incoming_date)}} e
                                {{FormatDate(variant.incoming_date, 11)}}
                            </strong>
                        </span>
                    </div>
                    <div class="PreSell__Variants__Item--Content" v-if="variant.show_inventory">
                        <span v-if="variant.show_inventory" class="PreSell__Variants__Item--Inventory">{{variant.quantityAvailable}} {{variant.quantityAvailable > 1 ? 'unidades disponíveis': 'unidade disponível'}}</span>
                    </div>
                    <div class="PreSell__Variants__Item--CTA">
                        <a href="#" @click="addProduct(variant._id)" class="btn btn-block btn-primary" :disabled="!variant.availableForSale" :class="{'btn-disabled': !variant.availableForSale}">
                            <span v-if="variant.availableForSale">
                                Compre com <br>
                                {{variant.discount}}% de desconto
                            </span>
                            <span v-else>
                                Esgotado
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        `,
        computed: {
            ...Vuex.mapGetters([
                'PreSellVariants'
            ]),
            ElegiblePreSellVariants(){
                return this.variants.slice(1, this.variants.length)
            }
        },
        props: ['variants'],
        created(){
            let $this = this
            $this.updateAvailableElegiblePreSellVariants();
            document.addEventListener('_EV.PreSell:add_product:most_recent', function(e) {
                $this.addProduct($this.ElegiblePreSellVariants[0]._id)
            })
            
        },
        updated(){
            let $this = this
            $this.updateAvailableElegiblePreSellVariants();
        },
        methods:{
            PreSellProductTitle(variant){
                return variant.name.replace('[[variant_discount]]', `${variant.discount}%`)
            }, 
            addProduct(variant_id){
                let id = variant_id;
                let hasBedBase = $('.buy-together.e-active input[type="checkbox"]').hasClass('e-active')
                
                EvolveCore.triggerEvent(`Minicart:add_product`, {
                    _id: id
                });

               
                
                
                EvolveCore.triggerEvent('cart:show')
                
                setTimeout(function(){
                    if (hasBedBase) {
                   
                        let idBedBase = $('.buy-together.e-active input[type="checkbox"]').attr('id')
                        console.log({idBedBase, hasBedBase})
                        EvolveCore.triggerEvent(`Minicart:add_product`, {
                            _id: idBedBase
                        });
                        console.log(">>>> add cama base")
                    }
                } , 1000)
             

                EvolveCore.triggerEvent(`PreSell:modal:close`);
            },
            FormatDate(date, days_to_add){
                var currentDate = new Date(date)
                if(days_to_add){
                    currentDate = currentDate.setDate(currentDate.getDate() + days_to_add);
                }
                return EvolveCore._helpers.dateFormat(currentDate)
            },
            updateAvailableElegiblePreSellVariants(){
                let $this = this
                let availableElegiblePreSellVariants = $this.ElegiblePreSellVariants.filter(variant => variant.availableForSale).length
                if(availableElegiblePreSellVariants > 0){
                    $this.$emit('has-elegible-variants', true)
                } else{
                    $this.$emit('has-elegible-variants', false)
                }
            }
        }
    })

    const PreSellStore = new Vuex.Store({
        state: {
            EvolveAPI: {
                BaseURL: 'https://evolvehub.azurewebsites.net/api/',
                AccessToken : sessionStorage.getItem("EvolveToken"),
                Credentials: {
                    apiKey: "emlzc291Onppc3NvdWJvbWJhbmRvMjAxOQ",
                    password: "YnVkYTpidWRhZXppc3NvdTIwMTk="
                }
            },
            PreSellVariants: null
        },
        getters: {
            PreSellState: state => {
                return state.PreSellState
            },
            PreSellVariants: state => {
                return state.PreSellVariants
            }
        },
        actions: {
            async getPreSellVariants({ state, commit, dispatch, rootState }, variant_reference=39483152728258) {
                try {
                    commit('setPreSellState',{variants:'LOADING'})
                    let currentPreSell = new ProductPreSell(variant_reference)
                    let $PreSellVariants = await currentPreSell.getProductPreSells();
                    EvolveCore.triggerEvent(`PreSellVariants:updated`, $PreSellVariants)
                    commit('setPreSellVariants', $PreSellVariants)
                    return commit('setPreSellState',{variants:'IDLE'})
                } catch (error) {
                    commit('setPreSellState',{variants:'ERROR'})
                    console.error(error.message)
                }
                
            },
            async setPreSellVariants({ commit }, value) {
                await commit('setPreSellVariants', value)
            },
    
        },
        mutations: {
            setPreSellState: function (state, PreSellStateOBJ) {
                state.PreSellState = {
                    ...state.PreSellState,
                    ...PreSellStateOBJ
                }
            },
            setPreSellVariants: function (state, PreSellVariantsARR) {
                EvolveCore.triggerEvent(`PreSell:variants:updated`, PreSellVariantsARR);
                state.PreSellVariants = PreSellVariantsARR
            }
        }
    })

    const $PreSellWidgets = document.querySelectorAll(".PreSell--Wrapper");
    const each = Array.prototype.forEach;
    each.call($PreSellWidgets, (el, index) => {
        return new Vue({
            el: el,
            store: PreSellStore,
            data() {
                return {
                    message: 'PreSell v1.0'
                }
            }
        })
    })
})
$(document).ready(function(){ 
    $('body').on('click', '.buy-together input', function(){
        $(this).toggleClass("e-active")
       
    });
 })